import cross from '~/assets/icons/cross.svg';
import piston from '~/assets/icons/piston.svg';
import { playSound, Sound } from '~/assets/sounds';
import { Text } from '~/components/ui/Text';
import { useModal } from '../../hooks';
import {
	StyledCloseButtonContainer,
	StyledContainer,
	StyledHeadingContainer,
} from './Head.styled';

const Head = () => {
	const { handleUnsavedChangesExitModal } = useModal();

	return (
		<StyledContainer>
			<StyledHeadingContainer>
				<img
					src={piston}
					width={30}
					height={30}
					style={{ userSelect: 'none', pointerEvents: 'none' }}
				/>
				<Text style={{ fontSize: '20px', fontWeight: 700, color: '#FFFFFF' }}>
					НАСТРОЙКА ТС
				</Text>
			</StyledHeadingContainer>
			<StyledCloseButtonContainer
				onClick={() => {
					handleUnsavedChangesExitModal();
					playSound(Sound.ClickButton);
				}}
				onMouseEnter={() => playSound(Sound.LinkCursor)}
			>
				<img src={cross} width={14} height={14} />
			</StyledCloseButtonContainer>
		</StyledContainer>
	);
};

export { Head };
